import { Component } from '@angular/core';
import { BarChartOneComponent } from '../../shared/components/charts/bar/bar-chart-one/bar-chart-one.component';
import { CommonModule } from '@angular/common';
import { PieChartComponent } from '../../shared/components/charts/pie-chart/pie-chart.component';


@Component({
  selector: 'app-gen-ai-dashboard',
  standalone: true,
  imports: [BarChartOneComponent, PieChartComponent, CommonModule],
  templateUrl: './gen-ai-dashboard.component.html'
})
export class GenAIDashboardComponent {
  transactionSeries = [
    850,
    214,
    96,
    88
  ];

  transactionLabels = [
    '850 PO',
    '214 ASN',
    '810 Invoice',
    '997 Ack'
  ];

  transactionColors = [
    '#465FFF',
    '#22C55E',
    '#EF4444',
  ];
  fileSeries = [
    45,
    25,
    15,
    10,
    5
  ];

  fileLabels = [
    'X12',
    'EDIFACT',
    'JSON',
    'XML',
    'CSV'
  ];

  fileColors = [
    '#465FFF',
    '#A855F7',
    '#06B6D4',
    '#22C55E',
    '#F59E0B'
  ];

  stats = [
    {
      title: 'Active Partners',
      value: '1,284',
      growth: '+12.5%',
      isPositive: true,
      theme: 'blue',
      icon: 'pi-users'  // 👥 Users/Partners icon
    },
    {
      title: 'Connections',
      value: '845',
      growth: '+6.2%',
      isPositive: true,
      theme: 'green',
      icon: 'pi-link'   // 🔗 Link/Connection icon
    },
    {
      title: 'AI Maps',
      value: '2,542',
      growth: '+18.8%',
      isPositive: true,
      theme: 'amber',
      icon: 'pi-sitemap'  // 🧠 Brain/AI icon
    },
    {
      title: 'Transactions',
      value: '98,542',
      growth: '+24.6%',
      isPositive: true,
      theme: 'red',
      icon: 'pi-send'  // 📄 Transaction/Document icon
    }
  ];

}